<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <component
      :is="item.component"
      v-for="(item, index) in cms.collection"
      :key="`primary_${index}`"
      v-editable="item"
      :cms="{
        ...item,
        color_text: { color: 'inherit' },
        color_hover: { color: 'inherit' },
        color_disabled: { color: 'inherit' },
        color_background: { color: 'transparent' },
        color_gradient: '',
      }"
      :class="`${name}__collection-primary`"
    />
    <component
      :is="item.component"
      v-for="(item, index) in cms.collection_secondary"
      :key="`secondary_${index}`"
      v-editable="item"
      :cms="{
        ...item,
        color_text: { color: 'inherit' },
        color_hover: { color: 'inherit' },
        color_disabled: { color: 'inherit' },
        color_background: { color: 'transparent' },
        color_gradient: '',
      }"
      :class="`${name}__collection-secondary`"
    />
  </section>
</template>

<script>
import data from '~/components/organisms/o-layout-x2-row/o-layout-x2-row.data'
import Colors from '~/mixins/colors'
export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-layout-x2-row',
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#000000',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.o-layout-x2-row {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }
  ::v-deep a {
    &:hover,
    &:active {
      color: var(--hover-color);
    }
  }
  ::v-deep .a-cta {
    &:hover,
    &:active {
      color: var(--text-color);
    }
  }
}
</style>
